/**
 * Extract only spoken content for preview display
 * Uses similar logic to preprocessScriptToSSML but returns plain text
 */
export function extractSpokenContent(raw: string): string {
  let content = raw;

  // Remove header sections (=== ... ===)
  content = content.replace(/^===.*?===$/gm, '');

  // Remove section headers (S1 –, S2 –, etc.)
  content = content.replace(/^S[0-9]+\s*–.*$/gm, '');

  // Remove "Agent Instructions (not spoken)" blocks and everything that follows until next section
  content = content.replace(/Agent Instructions \(not spoken\):?[\s\S]*?(?=\n\n[A-Z][^:]*:|$)/gi, '');
  content = content.replace(/Agent Instructions \(not spoken\)[\s\S]*?(?=\n\n|\n[A-Z][^:]*:|$)/gi, '');

  // Remove "System Rules (not spoken)" blocks
  content = content.replace(/System Rules \(not spoken\):?[\s\S]*?(?=\n\n[A-Z][^:]*:|$)/gi, '');
  content = content.replace(/System Rules \(not spoken\)[\s\S]*?(?=\n\n|\n[A-Z][^:]*:|$)/gi, '');

  // Remove "Company Details Reference (not spoken)" blocks
  content = content.replace(/Company Details Reference \(not spoken\):?[\s\S]*?(?=\n\n[A-Z][^:]*:|$)/gi, '');

  // Remove "Canonical Confirmation Lines" blocks
  content = content.replace(/Canonical Confirmation Lines[\s\S]*?(?=\n\n[A-Z][^:]*:|$)/gi, '');

  // Remove "Goal:" lines and their content
  content = content.replace(/^Goal:.*$/gm, '');

  // Remove "Rapport First:" and bullet points that follow
  content = content.replace(/^Rapport First:[\s\S]*?(?=\n\n[A-Z][^:]*:|$)/gm, '');

  // Remove any line containing "(not spoken)"
  content = content.replace(/.*\(not spoken\).*$/gm, '');

  // Remove [[INTERNAL: ...]] blocks
  content = content.replace(/\[\[INTERNAL:[\s\S]*?\]\]/g, '');

  // Remove lines that start with bullet points for instructions
  content = content.split('\n').filter(line => {
    const trimmed = line.trim();
    if (!trimmed) return true;
    
    // Remove instructional bullet points
    if (trimmed.startsWith('• ') && !trimmed.includes('"')) return false;
    
    // Remove lines that are clearly instructions/meta
    if (trimmed.startsWith('GLOBAL SAFE MODE RULES')) return false;
    if (trimmed.startsWith('Identity:')) return false;
    if (trimmed.startsWith('Avoid')) return false;
    if (trimmed.startsWith('Always')) return false;
    if (trimmed.startsWith('Never')) return false;
    if (trimmed.startsWith('If ')) return false;
    if (trimmed.startsWith('When ')) return false;
    if (trimmed.startsWith('Transition Examples:')) return false;
    if (trimmed.startsWith('Examples:')) return false;
    if (trimmed.startsWith('Pathfinding Flow:')) return false;
    if (trimmed.startsWith('Consent & Logging:')) return false;
    if (trimmed.startsWith('S2 Protection:')) return false;
    if (trimmed.startsWith('Fallback Path:')) return false;
    if (trimmed.startsWith('Tone Guidance:')) return false;
    
    return true;
  }).join('\n');

  // Keep only lines that are quoted spoken content or simple sentences
  content = content.split('\n').map(line => {
    const trimmed = line.trim();
    
    // Keep quoted content (spoken lines)
    if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
      return line;
    }
    
    // Keep bullet points that contain quotes (spoken options)
    if (trimmed.startsWith('• "') && trimmed.includes('"')) {
      return line;
    }
    
    // Keep [PAUSE] tokens for now (will be converted later)
    if (trimmed.includes('[PAUSE')) {
      return line;
    }
    
    // Remove everything else that looks like instructions
    if (trimmed.length > 0 && !trimmed.startsWith('"')) {
      return '';
    }
    
    return line;
  }).join('\n');

  // Clean up multiple blank lines
  content = content.replace(/\n{3,}/g, '\n\n').trim();

  return content;
}
